import api from "@/getinfo-api";

const archiveActions = {
  add: {
    contract: (contractId: string) => {
      return api.ContractApi.addToArchive(contractId);
    },
    act: (actId: string) => {
      return api.ActApi.addToArchive(actId);
    },
    bill: (billId: string) => {
      return api.BillApi.addToArchive(billId);
    },
    enrollmentOrder: (enrollmentOrderId: string) => {
      return api.EnrollmentOrderApi.addToArchive(enrollmentOrderId);
    },
    expulsionOrder: (expulsionOrderId: string) => {
      return api.ExpulsionOrderApi.addToArchive(expulsionOrderId);
    },
    educationProtocol: (educationProtocolId: string) => {
      return api.EducationProtocolApi.addToArchive(educationProtocolId);
    },
    finalDocument: (finalDocumentId: string) => {
      return api.FinalDocumentApi.addToArchive(finalDocumentId);
    }
  },
  remove: {
    contract: (contractId: string) => {
      return api.ContractApi.removeFromArchive(contractId);
    },
    act: (actId: string) => {
      return api.ActApi.removeFromArchive(actId);
    },
    bill: (billId: string) => {
      return api.BillApi.removeFromArchive(billId);
    },
    enrollmentOrder: (enrollmentOrderId: string) => {
      return api.EnrollmentOrderApi.removeFromArchive(enrollmentOrderId);
    },
    expulsionOrder: (expulsionOrderId: string) => {
      return api.ExpulsionOrderApi.removeFromArchive(expulsionOrderId);
    },
    educationProtocol: (educationProtocolId: string) => {
      return api.EducationProtocolApi.removeFromArchive(educationProtocolId);
    },
    finalDocument: (finalDocumentId: string) => {
      return api.FinalDocumentApi.removeFromArchive(finalDocumentId);
    }
  }
};

export { archiveActions };
